<script setup>
import { onMounted } from 'vue';
import SiteHeader from '~/components/SiteHeader.vue';
import SiteFooter from '~/components/SiteFooter.vue';


onMounted(() => {
});

</script>

<template>
  <div class="layout">
    <SiteHeader />
    <slot />
    <SiteFooter />
  </div>
</template>

<style scoped>

.layout {
  overflow-x: clip;
}

.page-enter-from,
.page-leave-to {
  filter: blur(10px);
  opacity: 0;
}

.page-enter-to,
.page-leave-from {
  filter: blur(0px);
  opacity: 1;
}
</style>
